import React, { useCallback } from 'react'

import { Icon, InfoOutlined } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'
import SubscriptionPromoSection from 'Pods/Shared/SubscriptionPromoSection/SubscriptionPromoSection'

function EmptySubscription({ viewEssentialsUrl = '/subscription', locale = 'en', promoSection = null }) {
  const t = useCallback(
    (key) => I18n.t(key, { ns: 'rails', lng: locale }),
    [locale]
  )

  return (
    <div className="empty-subscription">
      <div className="empty-subscription__message" role="status">
        <Icon svgComponent={InfoOutlined} color="dark" aria-hidden="true" />
        <span className="cgt-legacy-text-tiny empty-subscription__message-text">
          {t('subscription_management.empty_state.message')}
        </span>
        <a href={viewEssentialsUrl} className="cgt-legacy-link empty-subscription__link">
          {t('subscription_management.empty_state.view_essentials')}
        </a>
      </div>
      {promoSection && (
        <div className="empty-subscription__promo">
          <SubscriptionPromoSection
            {...promoSection}
            variant="profile-settings"
            trackPromo={false}
          />
        </div>
      )}
    </div>
  )
}

EmptySubscription.propTypes = {
  viewEssentialsUrl: string,
  locale: string,
  promoSection: shape({
    images: shape({
      wave: string.isRequired,
      waveLarge: string.isRequired,
      butterfly: string.isRequired,
      bird: string.isRequired,
      flower: string.isRequired,
    }).isRequired,
    locale: string,
    ctaUrl: string,
  }),
}

export default EmptySubscription
